<template>
  <div class="x-select">
    <ASelect
      v-bind="$attrs"
      v-on="$listeners"
      @change="change"
      option-filter-prop="children"
      :allowClear="true"
    >
      <template v-for="option in options">
        <a-select-option :key="option[valueKey]" :value="option[valueKey]">
          {{option[labelKey]}}
        </a-select-option>
      </template>
    </ASelect>
    <AIcon class="refresh-btn" :class="spin && 'spin'" type="sync" :spin="spin" @click.stop="$emit('refresh')"/>
  </div>
</template>
<script>

export default {
  props:{
    //数据接口
    options: {
      type: Array,
      require: true
    },
    spin: {
      type: Boolean,
      default: false
    },
    //展示内容的key 默认name
    labelKey: {
      type: String,
      default: "name"
    },
    //真实数据的key 默认id
    valueKey: {
      type: String,
      default: "id"
    },
  },
  data() {
    return {
      
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    //改变选择值
    change(key){
      this.$emit("input", key)
      //选择项回调
      let option = this.options.find(item => item[this.valueKey] == key)
      this.$emit("selected", option)
    }
  },
};
</script>
<style lang="less" scoped>
.x-select{
  width: 100%;
  position: relative;
  display: flex;
  /deep/ .ant-select{
    width: 100%;
    .ant-select-selection--single{
      .ant-select-selection__rendered{
        margin-right: 50px;
      }
    }
  }
  .refresh-btn{
    position: absolute;
    transform: translateY(-50%);
    font-size: 16px;
    top: 50%;
    right: 30px;
    color: #cfcfcf;
    z-index: 99999999;
    cursor: pointer;
    &.spin{
      color: @blue1;
    }
  }
}
</style>